module.exports = __webpack_public_path__ + "static/img/bannerOne.ae7fb43f.jpg";